var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacialRecognitionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4855 0C6.4815 0 0 6.496 0 14.5C0 22.504 6.4815 29 14.4855 29C22.504 29 29 22.504 29 14.5C29 6.496 22.504 0 14.4855 0ZM14.5 26.1C8.091 26.1 2.9 20.909 2.9 14.5C2.9 8.091 8.091 2.9 14.5 2.9C20.909 2.9 26.1 8.091 26.1 14.5C26.1 20.909 20.909 26.1 14.5 26.1ZM19.575 13.05C20.7785 13.05 21.75 12.0785 21.75 10.875C21.75 9.6715 20.7785 8.7 19.575 8.7C18.3715 8.7 17.4 9.6715 17.4 10.875C17.4 12.0785 18.3715 13.05 19.575 13.05ZM9.425 13.05C10.6285 13.05 11.6 12.0785 11.6 10.875C11.6 9.6715 10.6285 8.7 9.425 8.7C8.2215 8.7 7.25 9.6715 7.25 10.875C7.25 12.0785 8.2215 13.05 9.425 13.05ZM14.5 22.475C17.8785 22.475 20.7495 20.358 21.9095 17.4H7.0905C8.2505 20.358 11.1215 22.475 14.5 22.475Z",
    fill: "#004BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacialRecognitionIcon);
export default __webpack_public_path__ + "static/media/facialRecognitionIcon.1a3790d27f356badeaa9f1ac92ebf6b2.svg";
export { ForwardRef as ReactComponent };